export default "__VITE_ASSET__BcXCS6U1__"